import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation, Link } from "react-router-dom";
import Swal from "sweetalert2";
import MainLayout from "../../../components/layout/MainLayout";
import Breadcrumbs from "../../../components/common/Breadcrumbs";
import BDIForm from "./BDIForm";
import { fetchBdiAssessment, updateBdiAssessment } from "../../../store/slices/bdiAssessmentsSlice";
import { useDispatch } from "react-redux";
import { BDIFormQuestions } from "./BDIForm";

const EditBDI = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { state } = useLocation();
    const { caseId, patientId } = state || {};
    const [formData, setFormData] = useState({});
    const dispatch = useDispatch();
    const overrideKeys = {
        "suicidal_thoughts_or_wishes": "suicidal_thoughts",
        "changes_in_sleeping_pattern": "changes_in_sleeping",
        "tiredness_or_fatigue": "tiredness_fatigue"
    };


    useEffect(() => {
        const loadAssessment = async () => {
            try {
                const response = await dispatch(fetchBdiAssessment(id)).unwrap();
                // Map snake_case to camelCase for formData
                const mappedData = {
                    clientName: response.client_name || "",
                    diagnosis: response.diagnosis || "",
                    assessedBy: response.assessed_by || "",
                    caseId: response.case_id || null,
                    patientId: response.patient_id || null,
                };

                // Map all question scores back to q1, q2, ...
                console.log("Checking keys for each question:");
                BDIFormQuestions.forEach((q, index) => {
                    let key = q.title
                        .toLowerCase()
                        .replace(/[^a-z0-9]+/g, "_")
                        .replace(/^_+|_+$/g, "");

                    // backend field fix
                    if (overrideKeys[key]) {
                        key = overrideKeys[key];
                    }
                    mappedData[`q${index + 1}`] = response[`${key}_score`] !== undefined
                        ? String(response[`${key}_score`])
                        : "0";
                });

                setFormData(mappedData);
            } catch (error) {
                Swal.fire("Error", "Failed to load assessment.", "error");
            }
        };

        loadAssessment();
    }, [dispatch, id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const questionPayload = {};
        BDIFormQuestions.forEach((q, index) => {
            const qKey = `q${index + 1}`;
            const score = parseInt(formData[qKey] || 0, 10);
            const value = q.options[score] || "";

            // Convert question title → snake_case
            let key = q.title
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, "_")
                .replace(/^_+|_+$/g, "");

            // ⭐ APPLY OVERRIDE FIX HERE ⭐
            if (overrideKeys[key]) {
                key = overrideKeys[key];
            }

            questionPayload[`${key}_score`] = score;
            questionPayload[`${key}_value`] = value;
        });

        const payload = {
            patient_id: formData.patientId || null,
            case_id: formData.caseId || null,
            client_name: formData.clientName || "",
            diagnosis: formData.diagnosis || "",
            assessed_by: formData.assessedBy || "",
            ...questionPayload
        };

        try {
            await dispatch(updateBdiAssessment({ case_id: caseId, assessmentData: payload })).unwrap();
            Swal.fire("Updated!", "BDI-II assessment has been updated.", "success");
            // Stay on edit page
        } catch (error) {
            Swal.fire("Error", "Failed to update assessment.", "error");
        }
    };

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <Breadcrumbs />
                    <Link
                        to={`/phase04/bdi/print/${id}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-secondary"
                    >
                        <i className="ri-printer-line me-1"></i> Print
                    </Link>
                </div>
                <div className="card">
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <BDIForm formData={formData} handleChange={handleChange} />
                            <div className="col-12 d-flex justify-content-end mt-3">
                                <div className="col-md-2 d-flex justify-content-end">
                                    <button type="submit" className="btn btn-primary sticky-form-submit">
                                        <i className="ri-edit-2-line me-1"></i> Update
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default EditBDI;